import { Link } from 'wouter';

import { Calendar } from '~/client/components/Calendar';
import { Header } from '~/client/components/Header';
import { Icon } from '~/client/components/Icons';
import { AvatarStack, Button, Chip } from '~/client/components/Primitives';

export function Landing() {
  return (
    <>
      <Header variant="marketing" />
      <main className="app-main" style={{ padding: '40px 16px 80px' }}>
        <div className="container-marketing">
          <section className="hero-grid">
            <div>
              <h1 className="hero-display">
                when's <span className="hl">everyone</span>
                <br />
                free?
              </h1>
              <p className="hero-sub">
                pick a window. share a link. mates drop their dates. you see the overlap, ranked
                from "we're all in" to "good luck with that one".
              </p>
              <div className="row row-wrap" style={{ marginTop: 32, gap: 12 }}>
                <Link href="/new">
                  <Button variant="primary" size="lg">
                    Make a free poll <Icon name="arrow" size={16} />
                  </Button>
                </Link>
              </div>
              <div
                className="row row-wrap mono"
                style={{ marginTop: 24, color: 'var(--fg-muted)', fontSize: 13, gap: 18 }}
              >
                <span>· no sign-up</span>
                <span>· free forever</span>
                <span>· works on mobile</span>
              </div>
            </div>

            <div className="card-surface hero-card">
              <Calendar
                year={2026}
                month={5}
                mode="view"
                density={{
                  '2026-06-08': { yes: 2, maybe: 0 },
                  '2026-06-09': { yes: 4, maybe: 0 },
                  '2026-06-10': { yes: 5, maybe: 0 },
                  '2026-06-11': { yes: 5, maybe: 0 },
                  '2026-06-12': { yes: 5, maybe: 0 },
                  '2026-06-13': { yes: 3, maybe: 1 },
                  '2026-06-15': { yes: 3, maybe: 0 },
                  '2026-06-16': { yes: 4, maybe: 1 },
                  '2026-06-17': { yes: 5, maybe: 0 },
                  '2026-06-18': { yes: 5, maybe: 0 },
                  '2026-06-19': { yes: 4, maybe: 0 },
                  '2026-06-22': { yes: 2, maybe: 0 },
                  '2026-06-23': { yes: 3, maybe: 0 },
                  '2026-06-24': { yes: 2, maybe: 0 },
                  '2026-06-25': { yes: 1, maybe: 0 },
                }}
                total={5}
                monthNav={false}
              />
              <div className="row between" style={{ marginTop: 16 }}>
                <AvatarStack
                  people={[
                    { initials: 'JM', color: '#C8FF4A' },
                    { initials: 'SO', color: '#FFD5CC' },
                    { initials: 'RT', color: '#DCE3FB' },
                    { initials: 'AP', color: '#15181F', dark: true },
                    { initials: 'KW', color: '#E4FFA0' },
                  ]}
                />
                <Chip variant="lime" dot>
                  everyone in jun 10–12
                </Chip>
              </div>
            </div>
          </section>

          <section style={{ marginTop: 96 }}>
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontSize: 'clamp(28px, 6vw, 36px)',
                fontWeight: 600,
                letterSpacing: '-0.015em',
                margin: '0 0 32px',
              }}
            >
              three steps. no faff.
            </h2>
            <div className="grid-3">
              {[
                {
                  n: '01',
                  t: 'pick a window',
                  d: 'a single day, a week, three months — whatever you need.',
                },
                {
                  n: '02',
                  t: 'share the link',
                  d: 'we generate a short link. text it to the group chat. done.',
                },
                {
                  n: '03',
                  t: 'see the overlap',
                  d: "days light up as people respond. the brightest is when everyone's free.",
                },
              ].map(({ n, t, d }) => (
                <div key={n} className="card-surface step-card">
                  <div className="num">{n}</div>
                  <div className="title">{t}</div>
                  <p>{d}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </>
  );
}
